import React from "react";
import PropTypes from "prop-types";

import {
    Label,
    LabelContainer,
    ErrorContainer,
    LabelAndError,
    sharedFormStylesBase,
    sharedFormStylesPlaceholder,
    sharedFormStylesHover,
    sharedFormStylesFocus,
    sharedFormStylesDisabled,
    sharedFormStylesReadOnly
} from "./styles";

// all shared form styles:
export const SHARED_FORM_STYLES = {
    BASE: sharedFormStylesBase,
    PLACEHOLDER: sharedFormStylesPlaceholder,
    HOVER: sharedFormStylesHover,
    FOCUS: sharedFormStylesFocus,
    DISABLED: sharedFormStylesDisabled,
    READONLY: sharedFormStylesReadOnly
};

// shared form container:
export const FormElementContainer = ({
    className,
    labelText,
    showFormLabel,
    width = "100%",
    darkMode = false,
    errorMessage,
    hideVisualLabel = false,
    isPromoValid,
    children
}) => {
    return (
        <Label width={width} darkMode={darkMode} className={className}>
            {children}

            <LabelAndError>
                {!hideVisualLabel && (
                    <LabelContainer
                        showFormLabel={
                            showFormLabel &&
                            !errorMessage &&
                            isPromoValid !== 404
                        }
                        darkMode={darkMode}
                    >
                        {labelText}
                    </LabelContainer>
                )}

                <ErrorContainer
                    showError={
                        (!showFormLabel && !!errorMessage) ||
                        isPromoValid === 404
                    }
                    darkMode={darkMode}
                >
                    {isPromoValid === 404
                        ? "This promo code is not valid"
                        : errorMessage}
                </ErrorContainer>
            </LabelAndError>
        </Label>
    );
};

FormElementContainer.propTypes = {
    labelText: PropTypes.string.isRequired,
    showFormLabel: PropTypes.bool.isRequired,
    width: PropTypes.string,
    darkMode: PropTypes.bool,
    errorMessage: PropTypes.string,
    hideVisualLabel: PropTypes.bool,
    isPromoValid: PropTypes.number
};
